import { createAsyncAction, createAction } from 'typesafe-actions';
import { MhaContactsDto } from '../../common/dtos/dto';


export const getMhaContactsActions = createAsyncAction(
  'GET_MHA_CONTACTS_REQUEST',
  'GET_MHA_CONTACTS_SUCCESS',
  'GET_MHA_CONTACTS_ERROR'
)<undefined, MhaContactsDto[], string>();